import { Button, Typography } from '@mui/material'
import { useState } from 'react'
import { FORGOT_PASSWORD_URL } from 'services/constants'
import { postRequest } from 'utils/api'
import { getLocalUser } from 'utils/localStorage'
import { useTranslation } from 'react-i18next'
import { ColStack } from 'components/atoms/container/InCardStack'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import colors from 'styles/colors'
import CommonDialog from 'components/molecules/notificationOverlay/CommonDialog'
import OverlayLoading from 'components/atoms/OverlayLoading'

const ChangePasswordButton = () => {
  const { t } = useTranslation()
  const [successDialogOpen, setSuccessDialogOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleChangePasswordClick = async () => {
    setLoading(true)
    const user = getLocalUser()
    const res = await postRequest(FORGOT_PASSWORD_URL, {
      email: user.email
    })
    if (res.status === 200) {
      setSuccessDialogOpen(true)
    }
    setLoading(false)
  }
  return (
    <ColStack spacing={4}>
      <OverlayLoading open={loading} />
      <Typography variant='h5'>{t('profile.changeYourPassword')}</Typography>
      <Typography>{t('profile.sentResetEmail')}</Typography>
      <Button
        onClick={() => handleChangePasswordClick()}
        color='muted'
        size='small'
        startIcon={<LockOutlinedIcon sx={{ color: colors.MidnightTeal400 }} />}>
        {t('profile.changePassword')}
      </Button>
      <CommonDialog
        open={successDialogOpen}
        onClose={() => setSuccessDialogOpen(false)}
        titleText={t('profile.requestSubmitted')}
        notificationText={t('profile.checkYourEmail')}
        confirmText={t('rolePlay.okay')}
      />
    </ColStack>
  )
}

export default ChangePasswordButton
